var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAppoval(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2396_1431)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2396_1431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.458 42H71.2581C52.9277 42 42 52.9277 42 71.2581V113.458C42 131.789 52.9277 142.717 71.2581 142.717H113.458C131.789 142.717 142.717 131.789 142.717 113.458V71.2581C142.717 52.9277 131.789 42 113.458 42ZM82.1355 106.962L70.8049 118.293C70.0495 119.048 69.0927 119.401 68.1359 119.401C67.1791 119.401 66.172 119.048 65.4669 118.293L61.6901 114.516C60.1793 113.055 60.1793 110.638 61.6901 109.178C63.1505 107.718 65.5173 107.718 67.0281 109.178C67.6399 109.79 68.632 109.79 69.2438 109.178L76.7976 101.624C78.2579 100.164 80.6248 100.164 82.1355 101.624C83.5959 103.085 83.5959 105.502 82.1355 106.962ZM82.1355 71.7114L70.8049 83.042C70.0495 83.7974 69.0927 84.1499 68.1359 84.1499C67.1791 84.1499 66.172 83.7974 65.4669 83.042L61.6901 79.2651C60.1793 77.8047 60.1793 75.3875 61.6901 73.9271C63.1505 72.4667 65.5173 72.4667 67.0281 73.9271C67.6399 74.539 68.632 74.539 69.2438 73.9271L76.7976 66.3734C78.2579 64.913 80.6248 64.913 82.1355 66.3734C83.5959 67.8338 83.5959 70.251 82.1355 71.7114ZM120.357 115.624H93.9194C91.8547 115.624 90.1425 113.912 90.1425 111.847C90.1425 109.782 91.8547 108.07 93.9194 108.07H120.357C122.472 108.07 124.134 109.782 124.134 111.847C124.134 113.912 122.472 115.624 120.357 115.624ZM120.357 80.373H93.9194C91.8547 80.373 90.1425 78.6608 90.1425 76.5961C90.1425 74.5314 91.8547 72.8193 93.9194 72.8193H120.357C122.472 72.8193 124.134 74.5314 124.134 76.5961C124.134 78.6608 122.472 80.373 120.357 80.373Z",
    fill: "url(#paint0_linear_2396_1431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3816 108.824L67.3817 108.824L67.3756 108.818C65.6754 107.175 62.9987 107.165 61.3396 108.821C59.6295 110.478 59.6295 113.216 61.3395 114.872C61.3405 114.873 61.3415 114.874 61.3426 114.875L65.1076 118.64C65.922 119.509 67.0672 119.901 68.1359 119.901C69.2182 119.901 70.3044 119.5 71.1585 118.646L82.4891 107.316C84.1447 105.66 84.1447 102.926 82.4891 101.271L82.4891 101.271L82.483 101.265C80.7818 99.6202 78.1029 99.6117 76.444 101.271L68.8903 108.824C68.4737 109.241 67.7982 109.241 67.3816 108.824ZM67.3816 73.5736L67.3817 73.5735L67.3756 73.5676C65.6754 71.9242 62.9987 71.9147 61.3395 73.5706C59.6296 75.2268 59.6295 77.9652 61.3394 79.6215L65.1075 83.3896C65.9219 84.2581 67.0672 84.6499 68.1359 84.6499C69.2182 84.6499 70.3044 84.2496 71.1585 83.3955L82.4891 72.0649C84.1447 70.4093 84.1447 67.6755 82.4891 66.0198L82.4891 66.0198L82.483 66.0139C80.7818 64.3694 78.1029 64.361 76.444 66.0198L68.8903 73.5736C68.4737 73.9902 67.7982 73.9902 67.3816 73.5736ZM71.2581 42.5H113.458C122.524 42.5 129.699 45.2004 134.608 50.1087C139.516 55.0171 142.217 62.1924 142.217 71.2581V113.458C142.217 122.524 139.516 129.699 134.608 134.608C129.699 139.516 122.524 142.217 113.458 142.217H71.2581C62.1924 142.217 55.0171 139.516 50.1087 134.608C45.2004 129.699 42.5 122.524 42.5 113.458V71.2581C42.5 62.1924 45.2004 55.0171 50.1087 50.1087C55.0171 45.2004 62.1924 42.5 71.2581 42.5ZM93.9194 116.124H120.357C122.753 116.124 124.634 114.183 124.634 111.847C124.634 109.51 122.753 107.57 120.357 107.57H93.9194C91.5785 107.57 89.6425 109.506 89.6425 111.847C89.6425 114.188 91.5785 116.124 93.9194 116.124ZM93.9194 80.873H120.357C122.753 80.873 124.634 78.9326 124.634 76.5961C124.634 74.2596 122.753 72.3193 120.357 72.3193H93.9194C91.5785 72.3193 89.6425 74.2553 89.6425 76.5961C89.6425 78.937 91.5785 80.873 93.9194 80.873Z",
    stroke: "url(#paint1_linear_2396_1431)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2396_1431",
    x: 12.6764,
    y: 35.6764,
    width: 159.364,
    height: 159.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6618
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.47451 0 0 0 0 0.741176 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2396_1431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2396_1431",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9625 0 0 0 0 0.0601562 0 0 0 0 0.185482 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2396_1431"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2396_1431",
    x1: 40.9723,
    y1: 46.6098,
    x2: 257.829,
    y2: 206.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E144FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2396_1431",
    x1: 92.3583,
    y1: 42,
    x2: 92.3583,
    y2: 142.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2396_1431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 185,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppoval);
export default __webpack_public_path__ + "static/media/IconAppoval.ee1920c1d2f3295b1ffb21a2bbb97d56.svg";
export { ForwardRef as ReactComponent };